import { render, staticRenderFns } from "./Inquiry.vue?vue&type=template&id=cd0ed150&"
import script from "./Inquiry.vue?vue&type=script&lang=js&"
export * from "./Inquiry.vue?vue&type=script&lang=js&"
import style0 from "./Inquiry.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports